const { lazy } = require('react')

const AuthLayout = lazy(() => import('./AuthLayout'))
const MainLayout = lazy(() => import('./MainLayout'))

export { AuthLayout, MainLayout }
